/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
    QueryFunction,
    QueryKey,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    AffiliateAgentReportSuccessResponseResponse,
    AffiliateCancelledRefundedReportSuccessResponseResponse,
    AffiliateInvoiceDispatchParams,
    AffiliateInvoiceDispatchResponseResponse,
    AffiliateInvoiceReportSuccessResponseResponse,
    AffiliateSalesReportSuccessResponseResponse,
    BookingFeeReportSuccessResponseResponse,
    CommissionReportSuccessResponseResponse,
    GetAffiliateAgentReportParams,
    GetAffiliateCancelledRefundedReportParams,
    GetAffiliateInvoiceReportParams,
    GetAffiliateSalesReportParams,
    GetBookingFeeReportParams,
    GetCommissionReportParams,
    GetManifestReportParams,
    GetPayoutReportParams,
    GetSalesReportParams,
    GetTransactionsReportParams,
    ManifestReportSuccessResponseResponse,
    PayoutReportSuccessResponseResponse,
    SalesReportSuccessResponseResponse,
    TransactionsReportSuccessResponseResponse,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Dispatch affiliate invoice emails
 */
export const affiliateInvoiceDispatch = (
    params: AffiliateInvoiceDispatchParams,
    signal?: AbortSignal,
) => {
    return customInstance<AffiliateInvoiceDispatchResponseResponse>({
        url: `/reports/affiliate-invoice-dispatch`,
        method: 'GET',
        params,
        signal,
    });
};

export const getAffiliateInvoiceDispatchQueryKey = (params?: AffiliateInvoiceDispatchParams) => {
    return [`/reports/affiliate-invoice-dispatch`, ...(params ? [params] : [])] as const;
};

export const getAffiliateInvoiceDispatchQueryOptions = <
    TData = Awaited<ReturnType<typeof affiliateInvoiceDispatch>>,
    TError = APIErrorResponseResponse,
>(
    params: AffiliateInvoiceDispatchParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof affiliateInvoiceDispatch>>,
            TError,
            TData
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAffiliateInvoiceDispatchQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof affiliateInvoiceDispatch>>> = ({
        signal,
    }) => affiliateInvoiceDispatch(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof affiliateInvoiceDispatch>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type AffiliateInvoiceDispatchQueryResult = NonNullable<
    Awaited<ReturnType<typeof affiliateInvoiceDispatch>>
>;
export type AffiliateInvoiceDispatchQueryError = APIErrorResponseResponse;

/**
 * @summary Dispatch affiliate invoice emails
 */

export function useAffiliateInvoiceDispatch<
    TData = Awaited<ReturnType<typeof affiliateInvoiceDispatch>>,
    TError = APIErrorResponseResponse,
>(
    params: AffiliateInvoiceDispatchParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof affiliateInvoiceDispatch>>,
            TError,
            TData
        >;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getAffiliateInvoiceDispatchQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get booking-fee report for a venue
 */
export const getBookingFeeReport = (
    venueId: number,
    params?: GetBookingFeeReportParams,
    signal?: AbortSignal,
) => {
    return customInstance<BookingFeeReportSuccessResponseResponse>({
        url: `/venues/${venueId}/reports/booking-fees`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetBookingFeeReportQueryKey = (
    venueId?: number,
    params?: GetBookingFeeReportParams,
) => {
    return [`/venues/${venueId}/reports/booking-fees`, ...(params ? [params] : [])] as const;
};

export const getGetBookingFeeReportQueryOptions = <
    TData = Awaited<ReturnType<typeof getBookingFeeReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetBookingFeeReportParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getBookingFeeReport>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetBookingFeeReportQueryKey(venueId, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingFeeReport>>> = ({ signal }) =>
        getBookingFeeReport(venueId, params, signal);

    return { queryKey, queryFn, enabled: !!venueId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getBookingFeeReport>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetBookingFeeReportQueryResult = NonNullable<
    Awaited<ReturnType<typeof getBookingFeeReport>>
>;
export type GetBookingFeeReportQueryError = APIErrorResponseResponse;

/**
 * @summary Get booking-fee report for a venue
 */

export function useGetBookingFeeReport<
    TData = Awaited<ReturnType<typeof getBookingFeeReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetBookingFeeReportParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getBookingFeeReport>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetBookingFeeReportQueryOptions(venueId, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get sales report for a venue
 */
export const getSalesReport = (
    venueId: number,
    params?: GetSalesReportParams,
    signal?: AbortSignal,
) => {
    return customInstance<SalesReportSuccessResponseResponse>({
        url: `/venues/${venueId}/reports/sales`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetSalesReportQueryKey = (venueId?: number, params?: GetSalesReportParams) => {
    return [`/venues/${venueId}/reports/sales`, ...(params ? [params] : [])] as const;
};

export const getGetSalesReportQueryOptions = <
    TData = Awaited<ReturnType<typeof getSalesReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetSalesReportParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getSalesReport>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetSalesReportQueryKey(venueId, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesReport>>> = ({ signal }) =>
        getSalesReport(venueId, params, signal);

    return { queryKey, queryFn, enabled: !!venueId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getSalesReport>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetSalesReportQueryResult = NonNullable<Awaited<ReturnType<typeof getSalesReport>>>;
export type GetSalesReportQueryError = APIErrorResponseResponse;

/**
 * @summary Get sales report for a venue
 */

export function useGetSalesReport<
    TData = Awaited<ReturnType<typeof getSalesReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetSalesReportParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getSalesReport>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetSalesReportQueryOptions(venueId, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get transactions report for a venue
 */
export const getTransactionsReport = (
    venueId: number,
    params?: GetTransactionsReportParams,
    signal?: AbortSignal,
) => {
    return customInstance<TransactionsReportSuccessResponseResponse>({
        url: `/venues/${venueId}/reports/transactions`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetTransactionsReportQueryKey = (
    venueId?: number,
    params?: GetTransactionsReportParams,
) => {
    return [`/venues/${venueId}/reports/transactions`, ...(params ? [params] : [])] as const;
};

export const getGetTransactionsReportQueryOptions = <
    TData = Awaited<ReturnType<typeof getTransactionsReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetTransactionsReportParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getTransactionsReport>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTransactionsReportQueryKey(venueId, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransactionsReport>>> = ({
        signal,
    }) => getTransactionsReport(venueId, params, signal);

    return { queryKey, queryFn, enabled: !!venueId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getTransactionsReport>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetTransactionsReportQueryResult = NonNullable<
    Awaited<ReturnType<typeof getTransactionsReport>>
>;
export type GetTransactionsReportQueryError = APIErrorResponseResponse;

/**
 * @summary Get transactions report for a venue
 */

export function useGetTransactionsReport<
    TData = Awaited<ReturnType<typeof getTransactionsReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetTransactionsReportParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getTransactionsReport>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetTransactionsReportQueryOptions(venueId, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get payout report (platform → venue cash batches)
 */
export const getPayoutReport = (
    venueId: number,
    params?: GetPayoutReportParams,
    signal?: AbortSignal,
) => {
    return customInstance<PayoutReportSuccessResponseResponse>({
        url: `/venues/${venueId}/reports/payout`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetPayoutReportQueryKey = (venueId?: number, params?: GetPayoutReportParams) => {
    return [`/venues/${venueId}/reports/payout`, ...(params ? [params] : [])] as const;
};

export const getGetPayoutReportQueryOptions = <
    TData = Awaited<ReturnType<typeof getPayoutReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetPayoutReportParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getPayoutReport>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetPayoutReportQueryKey(venueId, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayoutReport>>> = ({ signal }) =>
        getPayoutReport(venueId, params, signal);

    return { queryKey, queryFn, enabled: !!venueId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getPayoutReport>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetPayoutReportQueryResult = NonNullable<Awaited<ReturnType<typeof getPayoutReport>>>;
export type GetPayoutReportQueryError = APIErrorResponseResponse;

/**
 * @summary Get payout report (platform → venue cash batches)
 */

export function useGetPayoutReport<
    TData = Awaited<ReturnType<typeof getPayoutReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetPayoutReportParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getPayoutReport>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetPayoutReportQueryOptions(venueId, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get manifest report for a venue
 */
export const getManifestReport = (
    venueId: number,
    params?: GetManifestReportParams,
    signal?: AbortSignal,
) => {
    return customInstance<ManifestReportSuccessResponseResponse>({
        url: `/venues/${venueId}/reports/manifest`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetManifestReportQueryKey = (
    venueId?: number,
    params?: GetManifestReportParams,
) => {
    return [`/venues/${venueId}/reports/manifest`, ...(params ? [params] : [])] as const;
};

export const getGetManifestReportQueryOptions = <
    TData = Awaited<ReturnType<typeof getManifestReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetManifestReportParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getManifestReport>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetManifestReportQueryKey(venueId, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManifestReport>>> = ({ signal }) =>
        getManifestReport(venueId, params, signal);

    return { queryKey, queryFn, enabled: !!venueId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getManifestReport>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetManifestReportQueryResult = NonNullable<
    Awaited<ReturnType<typeof getManifestReport>>
>;
export type GetManifestReportQueryError = APIErrorResponseResponse;

/**
 * @summary Get manifest report for a venue
 */

export function useGetManifestReport<
    TData = Awaited<ReturnType<typeof getManifestReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetManifestReportParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getManifestReport>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetManifestReportQueryOptions(venueId, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get commission report for a venue
 */
export const getCommissionReport = (
    venueId: number,
    params?: GetCommissionReportParams,
    signal?: AbortSignal,
) => {
    return customInstance<CommissionReportSuccessResponseResponse>({
        url: `/venues/${venueId}/reports/commission`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetCommissionReportQueryKey = (
    venueId?: number,
    params?: GetCommissionReportParams,
) => {
    return [`/venues/${venueId}/reports/commission`, ...(params ? [params] : [])] as const;
};

export const getGetCommissionReportQueryOptions = <
    TData = Awaited<ReturnType<typeof getCommissionReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetCommissionReportParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getCommissionReport>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCommissionReportQueryKey(venueId, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommissionReport>>> = ({ signal }) =>
        getCommissionReport(venueId, params, signal);

    return { queryKey, queryFn, enabled: !!venueId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getCommissionReport>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetCommissionReportQueryResult = NonNullable<
    Awaited<ReturnType<typeof getCommissionReport>>
>;
export type GetCommissionReportQueryError = APIErrorResponseResponse;

/**
 * @summary Get commission report for a venue
 */

export function useGetCommissionReport<
    TData = Awaited<ReturnType<typeof getCommissionReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetCommissionReportParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getCommissionReport>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetCommissionReportQueryOptions(venueId, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get affiliate sales report for a venue
 */
export const getAffiliateSalesReport = (
    venueId: number,
    params?: GetAffiliateSalesReportParams,
    signal?: AbortSignal,
) => {
    return customInstance<AffiliateSalesReportSuccessResponseResponse>({
        url: `/venues/${venueId}/reports/affiliate-sales`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetAffiliateSalesReportQueryKey = (
    venueId?: number,
    params?: GetAffiliateSalesReportParams,
) => {
    return [`/venues/${venueId}/reports/affiliate-sales`, ...(params ? [params] : [])] as const;
};

export const getGetAffiliateSalesReportQueryOptions = <
    TData = Awaited<ReturnType<typeof getAffiliateSalesReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetAffiliateSalesReportParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getAffiliateSalesReport>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAffiliateSalesReportQueryKey(venueId, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAffiliateSalesReport>>> = ({
        signal,
    }) => getAffiliateSalesReport(venueId, params, signal);

    return { queryKey, queryFn, enabled: !!venueId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getAffiliateSalesReport>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetAffiliateSalesReportQueryResult = NonNullable<
    Awaited<ReturnType<typeof getAffiliateSalesReport>>
>;
export type GetAffiliateSalesReportQueryError = APIErrorResponseResponse;

/**
 * @summary Get affiliate sales report for a venue
 */

export function useGetAffiliateSalesReport<
    TData = Awaited<ReturnType<typeof getAffiliateSalesReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetAffiliateSalesReportParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getAffiliateSalesReport>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetAffiliateSalesReportQueryOptions(venueId, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get cancelled and refunded affiliate bookings report for a venue
 */
export const getAffiliateCancelledRefundedReport = (
    venueId: number,
    params?: GetAffiliateCancelledRefundedReportParams,
    signal?: AbortSignal,
) => {
    return customInstance<AffiliateCancelledRefundedReportSuccessResponseResponse>({
        url: `/venues/${venueId}/reports/affiliate-cancelled-refunded`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetAffiliateCancelledRefundedReportQueryKey = (
    venueId?: number,
    params?: GetAffiliateCancelledRefundedReportParams,
) => {
    return [
        `/venues/${venueId}/reports/affiliate-cancelled-refunded`,
        ...(params ? [params] : []),
    ] as const;
};

export const getGetAffiliateCancelledRefundedReportQueryOptions = <
    TData = Awaited<ReturnType<typeof getAffiliateCancelledRefundedReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetAffiliateCancelledRefundedReportParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof getAffiliateCancelledRefundedReport>>,
            TError,
            TData
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetAffiliateCancelledRefundedReportQueryKey(venueId, params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getAffiliateCancelledRefundedReport>>
    > = ({ signal }) => getAffiliateCancelledRefundedReport(venueId, params, signal);

    return { queryKey, queryFn, enabled: !!venueId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getAffiliateCancelledRefundedReport>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetAffiliateCancelledRefundedReportQueryResult = NonNullable<
    Awaited<ReturnType<typeof getAffiliateCancelledRefundedReport>>
>;
export type GetAffiliateCancelledRefundedReportQueryError = APIErrorResponseResponse;

/**
 * @summary Get cancelled and refunded affiliate bookings report for a venue
 */

export function useGetAffiliateCancelledRefundedReport<
    TData = Awaited<ReturnType<typeof getAffiliateCancelledRefundedReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetAffiliateCancelledRefundedReportParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof getAffiliateCancelledRefundedReport>>,
            TError,
            TData
        >;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetAffiliateCancelledRefundedReportQueryOptions(
        venueId,
        params,
        options,
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get affiliate agent performance report for a venue
 */
export const getAffiliateAgentReport = (
    venueId: number,
    params?: GetAffiliateAgentReportParams,
    signal?: AbortSignal,
) => {
    return customInstance<AffiliateAgentReportSuccessResponseResponse>({
        url: `/venues/${venueId}/reports/affiliate-agents`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetAffiliateAgentReportQueryKey = (
    venueId?: number,
    params?: GetAffiliateAgentReportParams,
) => {
    return [`/venues/${venueId}/reports/affiliate-agents`, ...(params ? [params] : [])] as const;
};

export const getGetAffiliateAgentReportQueryOptions = <
    TData = Awaited<ReturnType<typeof getAffiliateAgentReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetAffiliateAgentReportParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getAffiliateAgentReport>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAffiliateAgentReportQueryKey(venueId, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAffiliateAgentReport>>> = ({
        signal,
    }) => getAffiliateAgentReport(venueId, params, signal);

    return { queryKey, queryFn, enabled: !!venueId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getAffiliateAgentReport>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetAffiliateAgentReportQueryResult = NonNullable<
    Awaited<ReturnType<typeof getAffiliateAgentReport>>
>;
export type GetAffiliateAgentReportQueryError = APIErrorResponseResponse;

/**
 * @summary Get affiliate agent performance report for a venue
 */

export function useGetAffiliateAgentReport<
    TData = Awaited<ReturnType<typeof getAffiliateAgentReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetAffiliateAgentReportParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getAffiliateAgentReport>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetAffiliateAgentReportQueryOptions(venueId, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get affiliate invoice report for a venue
 */
export const getAffiliateInvoiceReport = (
    venueId: number,
    params?: GetAffiliateInvoiceReportParams,
    signal?: AbortSignal,
) => {
    return customInstance<AffiliateInvoiceReportSuccessResponseResponse>({
        url: `/venues/${venueId}/reports/affiliate-invoice`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetAffiliateInvoiceReportQueryKey = (
    venueId?: number,
    params?: GetAffiliateInvoiceReportParams,
) => {
    return [`/venues/${venueId}/reports/affiliate-invoice`, ...(params ? [params] : [])] as const;
};

export const getGetAffiliateInvoiceReportQueryOptions = <
    TData = Awaited<ReturnType<typeof getAffiliateInvoiceReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetAffiliateInvoiceReportParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof getAffiliateInvoiceReport>>,
            TError,
            TData
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetAffiliateInvoiceReportQueryKey(venueId, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAffiliateInvoiceReport>>> = ({
        signal,
    }) => getAffiliateInvoiceReport(venueId, params, signal);

    return { queryKey, queryFn, enabled: !!venueId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getAffiliateInvoiceReport>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetAffiliateInvoiceReportQueryResult = NonNullable<
    Awaited<ReturnType<typeof getAffiliateInvoiceReport>>
>;
export type GetAffiliateInvoiceReportQueryError = APIErrorResponseResponse;

/**
 * @summary Get affiliate invoice report for a venue
 */

export function useGetAffiliateInvoiceReport<
    TData = Awaited<ReturnType<typeof getAffiliateInvoiceReport>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    params?: GetAffiliateInvoiceReportParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof getAffiliateInvoiceReport>>,
            TError,
            TData
        >;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetAffiliateInvoiceReportQueryOptions(venueId, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}
